var App = App || {};

App.SolutionsFinder = (function () {
    'use strict';

    function Init(selectorOrElement) {
        let elements;

        // Handle both jQuery objects and plain selectors/elements
        if (typeof selectorOrElement === 'string') {
            elements = document.querySelectorAll(selectorOrElement);
        } else if (selectorOrElement instanceof HTMLElement) {
            elements = [selectorOrElement];
        } else if (selectorOrElement && selectorOrElement.jquery) {
            // jQuery object - convert to array
            elements = Array.from(selectorOrElement);
        } else if (selectorOrElement && selectorOrElement.length) {
            elements = Array.from(selectorOrElement);
        } else {
            elements = [];
        }

        if (elements.length > 0) {
            elements.forEach(function(element) {
                Swipe(element);
                InitResultAnimations(element);
            });
        }
    }

    function Swipe(section) {
        const speed = 500;
        const wrapper = section.querySelector(".solutions-finder-tabs-wrapper");
        const widget = section.querySelector(".solutions-finder-tabs-swipe");
        const controls = section.querySelectorAll(".solutions-finder-nav-arrow");
        const scroll = widget ? widget.querySelector(".solutions-finder-scroll") : null;
        const content = scroll ? scroll.querySelector(".solutions-finder-nav-tabs") : null;
        const tabs = content ? Array.from(content.querySelectorAll(".nav-link[role='tab']")) : [];
        const arrowsContainer = section.querySelector(".solutions-finder-arrows");
        const leftArrow = section.querySelector(".solutions-finder-nav-arrow-left");
        const rightArrow = section.querySelector(".solutions-finder-nav-arrow-right");

        if (!wrapper || !widget || !content || !scroll || tabs.length === 0) {
            return;
        }

        function getTabText(tab) {
            return tab ? tab.textContent.replace(/\s+/g, " ").trim() : "";
        }

        function getActiveTabIndex() {
            const activeIndex = tabs.findIndex(function (tab) {
                return tab.classList.contains("active") || tab.getAttribute("aria-selected") === "true";
            });

            return activeIndex >= 0 ? activeIndex : 0;
        }

        function setArrowState(arrow, isDisabled, ariaLabel) {
            if (!arrow) {
                return;
            }

            arrow.classList.toggle("disabled", isDisabled);
            arrow.setAttribute("aria-disabled", isDisabled ? "true" : "false");
            arrow.setAttribute("aria-label", ariaLabel);
        }

        function smoothScrollTo(element, target, duration) {
            const maxScroll = Math.max(0, element.scrollWidth - element.clientWidth);
            const boundedTarget = Math.max(0, Math.min(target, maxScroll));
            const start = element.scrollLeft;
            const change = boundedTarget - start;
            const startTime = performance.now();

            function animateScroll(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const ease = progress < 0.5
                    ? 2 * progress * progress
                    : 1 - Math.pow(-2 * progress + 2, 2) / 2;

                element.scrollLeft = start + (change * ease);

                if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                }
            }

            requestAnimationFrame(animateScroll);
        }

        function ensureTabInView(tab, animated) {
            if (!tab) {
                return;
            }

            const overlayOffset = arrowsContainer && window.innerWidth < 1400
                ? arrowsContainer.offsetWidth
                : 0;
            const viewportLeft = scroll.scrollLeft;
            const viewportRight = viewportLeft + scroll.clientWidth - overlayOffset;
            const tabLeft = tab.offsetLeft;
            const tabRight = tabLeft + tab.offsetWidth;
            const padding = 24;
            let targetScroll = viewportLeft;

            if (tabLeft < viewportLeft + padding) {
                targetScroll = tabLeft - padding;
            } else if (tabRight > viewportRight - padding) {
                targetScroll = tabRight - (scroll.clientWidth - overlayOffset) + padding;
            }

            if (Math.abs(targetScroll - viewportLeft) < 1) {
                return;
            }

            if (animated) {
                smoothScrollTo(scroll, targetScroll, speed);
            } else {
                const maxScroll = Math.max(0, scroll.scrollWidth - scroll.clientWidth);
                scroll.scrollLeft = Math.max(0, Math.min(targetScroll, maxScroll));
            }
        }

        function activateTabByIndex(index) {
            if (index < 0 || index >= tabs.length) {
                return;
            }

            const tab = tabs[index];
            if (window.bootstrap && window.bootstrap.Tab) {
                window.bootstrap.Tab.getOrCreateInstance(tab).show();
            } else {
                tab.click();
            }
        }

        function updateControls() {
            const hasOverflow = scroll.scrollWidth > scroll.clientWidth;
            const activeIndex = getActiveTabIndex();
            const activeTab = tabs[activeIndex];
            const previousTab = tabs[activeIndex - 1];
            const nextTab = tabs[activeIndex + 1];
            const hasPrevious = activeIndex > 0;
            const hasNext = activeIndex < tabs.length - 1;

            if (hasOverflow) {
                wrapper.classList.toggle("mask-back", hasPrevious);
                wrapper.classList.toggle("mask-fwd", hasNext);
            } else {
                wrapper.classList.remove("mask-fwd", "mask-back");
            }

            setArrowState(
                leftArrow,
                !hasPrevious,
                hasPrevious
                    ? "Go to previous tab: " + getTabText(previousTab)
                    : "Current tab is first in the list: " + getTabText(activeTab)
            );

            setArrowState(
                rightArrow,
                !hasNext,
                hasNext
                    ? "Go to next tab: " + getTabText(nextTab)
                    : "Current tab is last in the list: " + getTabText(activeTab)
            );
        }

        controls.forEach(function (control) {
            control.addEventListener("click", function (e) {
                e.preventDefault();

                if (control.classList.contains("disabled")) {
                    return;
                }

                const direction = control.getAttribute("data-swipe");
                const activeIndex = getActiveTabIndex();

                if (direction === "back") {
                    activateTabByIndex(activeIndex - 1);
                } else if (direction === "fwd") {
                    activateTabByIndex(activeIndex + 1);
                }
            });
        });

        tabs.forEach(function (tab) {
            tab.addEventListener("shown.bs.tab", function () {
                ensureTabInView(this, true);
                updateControls();
            });

            tab.addEventListener("focus", function () {
                ensureTabInView(this, true);
            });
        });

        setTimeout(function () {
            ensureTabInView(tabs[getActiveTabIndex()], false);
            updateControls();
        }, 100);

        window.addEventListener("load", function () {
            setTimeout(function () {
                ensureTabInView(tabs[getActiveTabIndex()], false);
                updateControls();
            }, 100);
        });

        window.addEventListener("resize", function () {
            ensureTabInView(tabs[getActiveTabIndex()], false);
            updateControls();
        });
    }

    function InitResultAnimations(section) {
        if (!section || section.dataset.sfAnimationsInitialized === "true") {
            return;
        }

        section.dataset.sfAnimationsInitialized = "true";

        if (window.jQuery && typeof window.jQuery.fn.ZagScrollAnimate === "function") {
            window.jQuery(section).ZagScrollAnimate({
                offset: 75,
                targets: [
                    { selector: ".tab-pane.active.show .solution-overlay-card-content", type: "animate__fadeInUp", stagger: 560 },
                    { selector: ".tab-pane.active.show .solution-item", type: "animate__fadeInUp", stagger: 560 },
                    { selector: ".tab-pane.active.show .solution-icon-overlay", type: "animate__swing", stagger: 320 }
                ],
                overflow: false
            });
        }

        const navTabs = section.querySelector(".solutions-finder-nav-tabs");
        if (navTabs) {
            // Trigger after Bootstrap finishes activating the new tab pane.
            navTabs.addEventListener("shown.bs.tab", function (event) {
                const shownTab = event && event.target ? event.target.closest(".nav-link") : null;
                if (!shownTab) {
                    return;
                }

                AnimateActiveTabIcon(section, shownTab);
                AnimateActiveTabResults(section);
            });

            // Fallback for cases where the Bootstrap event does not fire as expected.
            navTabs.addEventListener("click", function (event) {
                const clickedTab = event && event.target ? event.target.closest(".nav-link") : null;
                if (!clickedTab) {
                    return;
                }

                window.setTimeout(function () {
                    const activeTab = section.querySelector(".solutions-finder-nav-tabs .nav-link.active");
                    AnimateActiveTabIcon(section, activeTab || clickedTab);
                    AnimateActiveTabResults(section);
                }, 220);
            });
        }

        AnimateActiveTabIcon(section);
        AnimateActiveTabResults(section);
    }

    function AnimateActiveTabIcon(section, shownTab) {
        const tabs = section.querySelectorAll(".solutions-finder-nav-tabs .nav-link");
        tabs.forEach(function (tab) {
            const icon = tab.querySelector(".icon");
            if (!icon) {
                return;
            }

            icon.classList.remove("animate__animated", "animate__swing");
            icon.style.animationDelay = "0ms";
            icon.style.animationDuration = "";
            icon.style.removeProperty("--animate-duration");
        });

        const activeTab = shownTab || section.querySelector(".solutions-finder-nav-tabs .nav-link.active");
        if (!activeTab) {
            return;
        }

        const activeIcon = activeTab.querySelector(".icon");
        ReTriggerAnimation(activeIcon, "animate__swing", 120, 1400);
    }

    function AnimateActiveTabResults(section) {
        const tabContent = section.querySelector(".section-layout > .tab-content");
        if (!tabContent) {
            return;
        }

        const activePanel = tabContent.querySelector(".tab-pane.active.show") || tabContent.querySelector(".tab-pane");
        if (!activePanel) {
            return;
        }

        const overlayCards = activePanel.querySelectorAll(".solution-overlay-card-content");
        overlayCards.forEach(function (card, index) {
            ReTriggerAnimation(card, "animate__fadeInUp", index * 560, 1500);
        });

        const solutionItems = activePanel.querySelectorAll(".solution-item");
        solutionItems.forEach(function (item, index) {
            ReTriggerAnimation(item, "animate__fadeInUp", 360 + (index * 560), 1500);
        });

        const iconOverlays = activePanel.querySelectorAll(".solution-icon-overlay");
        iconOverlays.forEach(function (iconOverlay, index) {
            ReTriggerAnimation(iconOverlay, "animate__swing", 700 + (index * 320), 1600);
        });
    }

    function ReTriggerAnimation(element, animationClass, delayMs, durationMs) {
        if (!element) {
            return;
        }

        element.classList.remove("animate__animated", "animate__fadeInUp", "animate__swing");
        void element.offsetWidth;
        element.classList.add("animate__animated", animationClass);
        element.style.animationDelay = delayMs > 0 ? delayMs + "ms" : "0ms";
        if (durationMs) {
            element.style.animationDuration = durationMs + "ms";
            element.style.setProperty("--animate-duration", durationMs + "ms");
        }
    }

    return {
        Init: Init
    };

})();

